import {
  DropdownMenuContent,
  DropdownMenuItem,
} from "@/components/ui/dropdown-menu";
import { useOptimisticRemove } from "@/hooks/useOptimisticRemove";
import { deletePursuitTask } from "@/features/pursuit/api/apiPursuitTask";

import { Trash2 } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function PursuitTaskOperations({ pursuitId, taskId }) {
  const removeFilterFn = (task) => {
    return task.id !== taskId;
  };
  const { mutate: removePursuit } = useOptimisticRemove(
    ["pursuit-tasks", pursuitId],
    deletePursuitTask,
    removeFilterFn
  );
  const navigate = useNavigate();
  return (
    <DropdownMenuContent>
      <DropdownMenuItem
        onClick={(e) => {
          e.stopPropagation();
          removePursuit(taskId, {
            onSuccess: () => {
              navigate(`/journey-hub/${pursuitId}/overview`);
            },
          });
        }}
      >
        <Trash2 className="mr-2 h-4 w-4 text-destructive" />
        Delete
      </DropdownMenuItem>
    </DropdownMenuContent>
  );
}
